(function () {
    const modal = document.querySelector('[data-modal-fraud]');

    if (modal) {
        const closes = modal.querySelectorAll('[data-modal-close]');
        const wrapper = modal.querySelector('[data-modal-wrap]');

        const closeModal = () => {
            const expires = new Date(Date.now() + (3600 * 1000 * 24)).toUTCString();
            const domain = document.location.hostname;

            document.cookie = "fraud_alert=1; path=/; domain=" + domain + "; expires=" + expires + "; secure; SameSite=Strict";
            modal.classList.remove('modal_active');
        }

        closes.forEach(close => {
            close.addEventListener('click', () => closeModal());
        });

        modal.addEventListener('click', (e) => {
            if (!wrapper.contains(e.target)) closeModal()
        });
    }
}());
